import React from 'react';
import { Grid, ClickAwayListener, Paper } from '@mui/material';
import ShowPassengersButton from '../PassengersComponent/ShowPassengersButton';
import Passengers from '../PassengersComponent/Passengers';

import {
  containerSx,
  passengersButtonSx,
  popoverSx,
  searchButtonSx,
  SearchButton,
} from './styles';

const PaxSearchPanel = ({
  handleClick,
  showPassengers,
  handleClose,
  setFlightClass,
  flightClass,
  executeSearch,
  searchPax,
  setSearchPax,
  setPaxError,
  paxError,
  ...props
}) => {
  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      sx={{ ...containerSx }}
      id="passengers-search-wrapper"
      {...props}
    >
      <Grid
        item
        sx={{ ...passengersButtonSx }}
        id="passengers-button-container"
      >
        <ShowPassengersButton
          handleClick={handleClick}
          passengersCount={searchPax.adults + (searchPax.childs.length ?? 0)}
          id="show-passengers-button"
        />

        {showPassengers && (
          <ClickAwayListener onClickAway={handleClose}>
            <Paper elevation={3} sx={{ ...popoverSx }} id="passengers-popover">
              <Passengers
                passengersValue={searchPax.adults}
                initialChilds={searchPax.childs}
                setFlightClassOneWay={setFlightClass}
                handleClose={handleClose}
                initFlightClass={flightClass}
                setSearchPax={setSearchPax}
                setPaxError={setPaxError}
                paxError={paxError}
              />
            </Paper>
          </ClickAwayListener>
        )}
      </Grid>

      <Grid item sx={{ ...searchButtonSx }} id="search-button-container">
        <SearchButton
          variant="contained"
          id="search-button"
          onClick={() => {
            if (paxError) return;
            executeSearch();
          }}
        >
          BUSCAR
        </SearchButton>
      </Grid>
    </Grid>
  );
};

export default PaxSearchPanel;
